import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import EnhancedCopy from '../EnhancedCopy'
import { MagazinePage } from '@types/magazine'
import { Box, Typography } from '@ds/components'
import { useBreakpointStyles } from '@components/BreakpointStyle'
import EnhancedLink from '@components/EnhancedLink'

const Article = ({ article, divider }: { article: MagazinePage; divider?: JSX.Element }) => {
    const { id, title, uri, excerpt, featuredImage } = article

    const { classes } = useBreakpointStyles()

    function showArticleImage(br: string, p: string, mw: number) {
        const image = getImage(featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData)

        if (!image) {
            return null
        }

        return (
            <Box flexGrow={0} sx={{ maxWidth: mw, verticalAlign: 'top', mr: 2 }}>
                <EnhancedLink to={uri}>
                    <GatsbyImage
                        key={`article-image-${id}`}
                        image={image}
                        alt={title}
                        style={{ borderRadius: br, padding: p }}
                    />
                </EnhancedLink>
            </Box>
        )
    }

    return (
        <>
            <Box key={`article-${id}`}>
                <Box display="flex" alignItems={'center'}>
                    <Box className={classes.showDesktop}>{showArticleImage('12%', '80px', 160)}</Box>
                    <Box>
                        <Typography variant="subtitle2">
                            <EnhancedLink to={uri}>{title}</EnhancedLink>
                        </Typography>

                        <Box className={classes.showDesktop}>
                            <EnhancedCopy enhancedCopy={excerpt} />
                        </Box>
                    </Box>
                </Box>
            </Box>
            {divider}
        </>
    )
}

export default Article
